import React from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'

const ShortenUrl = () => {
  const context = useOutletContext();
  return (
    <Outlet context={context}/>
  )
}

export default ShortenUrl

